import Vuex from 'vuex';

// Stores
import uploads from 'shared/stores/uploads';
import liveSession from './stores/live-session';
import metadataEditor from 'shared/stores/metadata-editor';

/** @param {import('vue').VueConstructor} app */
export function createStore(app) {
    app.use(Vuex);

    const store = new Vuex.Store({
        strict: window.BSTG.env !== 'production',
        devtools: window.BSTG.env !== 'production',
        plugins: ['development', 'dev', 'aws-dev'].includes(window.BSTG.env) ? [Vuex.createLogger()] : [],
        modules: {
            uploads,
            liveSession: liveSession(app.prototype.$utils),
            metadataEditor,
        }
    });

    return store;
}
